import { Alignment, Category, Selection } from 'pages/Customers/CustomerSearch/enums'

export const filtersFriendlyNames = {
  hehm_good: 'Good',
  hehm_fair: 'Needs Maintenance',
  hehm_critical: 'Needs Attention',

  hehm_recently_disconnected: 'Disconnected < 24 hrs',
  hehm_disconnected_24_hrs: 'Disconnected 24 hrs',
  hehm_disconnected_7_days: 'Disconnected 7 days',

  hehm_filter_health_good: 'Good',
  hehm_filter_health_fair: 'Fair',
  hehm_filter_health_needs_replacement: 'Needs Replacement',

  sda_critical: 'SDA Critical',
  sda_major: 'SDA Major',
  sda_minor: 'SDA Minor',

  connected: 'Connected',
  disconnected: 'Disconnected'
}

export const appliedFiltersFriendlyNames = {
  hehm_good: 'good',
  hehm_fair: 'needs maintenance',
  hehm_critical: 'needs attention',

  hehm_recently_disconnected: 'EHMKT-disconnected < 24 hrs',
  hehm_disconnected_24_hrs: 'EHMKT-disconnected 24 hrs',
  hehm_disconnected_7_days: 'EHMKT-disconnected 7 days',

  hehm_filter_health_good: 'filter health-good',
  hehm_filter_health_fair: 'filter health-fair',
  hehm_filter_health_needs_replacement: 'filter health-replacement',

  critical: 'alert-critical',
  major: 'alert-major',
  minor: 'alert-minor',
  sda_critical: 'alert-sda critical',
  sda_major: 'alert-sda major',
  sda_minor: 'alert-sda minor',
  dirty_filter: 'alert-dirty filter',

  connected: 'connected',
  disconnected: 'disconnected',

  active: 'active service contract',
  expired: 'expired service contract',
  no_contract: 'no service contract',

  new: 'new customer',
  updated: 'updated customer',
  duplicate: 'duplicate customer',

  // Device Models
  '724': 'XR724',
  '824': 'XL824',
  '824c': 'XL824C',
  '850': 'XL850',
  '1050': 'XL1050',
  'SC360': 'SC360',
  'PIVOT': 'Pivot',
  'EHMKT': 'EHMKT',
  '24P': '24P',
  '24C': '24C'
}

export const filterGroups = () => {
  const FILTER_GROUPS = [
    { category: Category.HEHM, alignItems: Alignment.LEFT, label: 'Health Score', rule: Selection.SINGLE, filters: ['hehm_good', 'hehm_fair', 'hehm_critical'] },
    { category: Category.HEHM, alignItems: Alignment.LEFT, label: 'Filter Health', rule: Selection.SINGLE, filters: ['hehm_filter_health_good', 'hehm_filter_health_fair', 'hehm_filter_health_needs_replacement'] },

    { category: Category.Thermostat, alignItems: Alignment.RIGHT, label: 'Enrollment Status', rule: Selection.SINGLE, filters: ['opted_in', 'opted_out', 'not_enrolled'] },
    { category: Category.Thermostat, alignItems: Alignment.RIGHT, label: 'Service Contract', rule: Selection.SINGLE, filters: ['active', 'expired', 'no_contract'] },

    { category: Category.None, alignItems: Alignment.CENTER, label: 'Alerts', rule: Selection.MULTI, filters: ['critical', 'major', 'minor', 'sda_critical', 'sda_major', 'sda_minor', 'dirty_filter'] },
    { category: Category.None, alignItems: Alignment.CENTER, label: 'Connection Status', rule: Selection.SINGLE, filters: ['connected', 'disconnected', 'hehm_recently_disconnected', 'hehm_disconnected_24_hrs', 'hehm_disconnected_7_days'] },
    { category: Category.None, alignItems: Alignment.LEFT, label: 'Customer Info', rule: Selection.SINGLE, filters: ['new', 'updated', 'duplicate'] },
    { category: Category.None, alignItems: Alignment.RIGHT, label: 'Pinned Status', rule: Selection.SINGLE, filters: ['pinned', 'unpinned'] },
    { category: Category.None, alignItems: Alignment.CENTER, label: 'Models', rule: Selection.SINGLE, filters: ['724', '824', '824c', '850', '1050', 'SC360', 'PIVOT', 'EHMKT', '24P', '24C'] },
    { category: Category.None, alignItems: Alignment.CENTER, label: 'Action', rule: Selection.MULTI, filters: ['resolved', 'scheduled_repair', 'scheduled_maintenance', 'customer_action_required', 'actively_monitoring', 'ordered_parts', 'won\'t_fix'] }
  ]

  return FILTER_GROUPS
}

export const filterGroupsWithoutHEHM = () => {
  const FILTER_GROUPS = [
    { category: Category.Thermostat, alignItems: Alignment.LEFT, label: 'Status', rule: Selection.SINGLE, filters: ['opted_in', 'opted_out', 'not_enrolled'] },
    { category: Category.None, alignItems: Alignment.LEFT, label: 'Action', rule: Selection.MULTI, filters: ['resolved', 'scheduled_repair', 'scheduled_maintenance', 'customer_action_required', 'actively_monitoring', 'ordered_parts', 'won\'t_fix'] },
    { category: Category.Thermostat, alignItems: Alignment.LEFT, label: 'Service Contract', rule: Selection.SINGLE, filters: ['active', 'expired', 'no_contract'] },
    { category: Category.None, alignItems: Alignment.LEFT, label: 'Thermostats', rule: Selection.SINGLE, filters: ['724', '824', '824c', '850', '1050', 'SC360', 'PIVOT'] },
    { category: Category.Thermostat, alignItems: Alignment.RIGHT, label: 'Alerts', rule: Selection.MULTI, filters: ['critical', 'major', 'minor', 'sda_major', 'sda_minor', 'dirty_filter'] },
    { category: Category.Thermostat, alignItems: Alignment.RIGHT, label: 'Connection', rule: Selection.SINGLE, filters: ['connected', 'disconnected'] },
    { category: Category.None, alignItems: Alignment.RIGHT, label: 'Customer Info', rule: Selection.SINGLE, filters: ['new', 'updated', 'duplicate'] },
    { category: Category.None, alignItems: Alignment.RIGHT, label: 'Pin Status', rule: Selection.SINGLE, filters: ['pinned', 'unpinned'] }
  ]

  return FILTER_GROUPS
}
